import React, { useState } from "react";
import axios from "axios";
import ButtonPrimary from "../Button-primary";
import ArrowUp from "../../assets/icons/Arrow-up";

const ProfileInfos = ({ userData }) => {
  const [editedUserData, setEditedUserData] = useState({});
  const [isEditing, setIsEditing] = useState(false);
  const [isHidden, setIsHidden] = useState(true);
  const [isPasswordHidden, setIsPasswordHidden] = useState(true);
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setEditedUserData({ ...editedUserData, [name]: value });
  };

  const toggleHidden = () => {
    setIsHidden(!isHidden);
  };

  const handleEdit = async (e) => {
    e.preventDefault();

    const formData = new FormData(e.target);

    const editedUserData = {
      name: formData.get("name"),
      email: formData.get("email"),
      address: formData.get("address"),
    };

    try {
      await axios.put(
        "https://cryptools-server-production.up.railway.app/api/user",
        editedUserData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      setEditedUserData({});
      setIsEditing(false);
      alert("User data updated successfully!");
      window.location.reload();
    } catch (error) {
      console.error(error);
    }
  };

  const handleChangePassword = async (event) => {
    event.preventDefault();
    setErrorMessage('');

    const response = await fetch(
      'https://cryptools-server-production.up.railway.app/api/user/changePassword',
      // 'http://localhost:4000/api/user/changePassword',
      {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        oldPassword,
        newPassword,
      }),
    });

    if (response.ok) {
      alert('Password changed successfully!');
      setOldPassword('');
      setNewPassword('');
      setIsPasswordHidden(true);
    } else {
      const errorData = await response.json();
      setErrorMessage(errorData.message);
      alert(errorData.message);
    }
  };

  const monitoredTokens = userData?.user?.monitoredToken || [];
    const totalTokens = userData?.user?.monitoredToken?.length || 0;

    const lastVestingDate = userData?.user?.monitoredToken
    ?.map(token => token.vestingDate)
    .sort((a, b) => new Date(b) - new Date(a))[0];

  const formattedLastVestingDate = lastVestingDate 
    ? new Date(lastVestingDate).toLocaleDateString('fr-FR', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })
    : 'Aucune date de vesting';

    const averageReceivedPercentage = userData?.user?.monitoredToken?.length > 0
    ? userData.user.monitoredToken.reduce((acc, token) => {
        // Calculer le pourcentage reçu pour chaque token
        const percentageReceived = token.to_receive > 0
          ? (token.receivedAmount / token.to_receive) * 100
          : 0;
        return acc + percentageReceived;
      }, 0) / userData.user.monitoredToken.length
    : 0;

  // Arrondir à deux décimales
  const formattedAverageReceivedPercentage = averageReceivedPercentage.toFixed(2);

  const repartitionByBlockchain = monitoredTokens.reduce((acc, token) => {
    acc[token.blockchain] = (acc[token.blockchain] || 0) + 1;
    return acc;
  }, {});

  const formatBlockchainName = (name) => {
    return name.split('-')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  const repartitionPercentage = Object.entries(repartitionByBlockchain)
    .map(([blockchain, count]) => ({
      blockchain: formatBlockchainName(blockchain),
      count,
      percentage: totalTokens > 0 ? ((count / totalTokens) * 100).toFixed(2) : '0.00'
    }))
    .sort((a, b) => b.count - a.count);

  return (
    <div className="flex flex-col gap-5">
      <div className="max-w-lg">
        <h1 className="text-2xl font-bold">
          Hello <span className="text-indigo-500">{userData?.user?.name}</span>
        </h1>
        <p className="mt-2 mb-2 text-gray-600">Welcome to your dashboard</p>
      </div>
      <div className="flex items-center justify-between gap-8 p-4 border-2 border-gray-200 rounded-md">
        <div className="flex flex-col w-2/6 gap-2">
      <div className="flex gap-2">
          <span className="font-bold">Number of monitored tokens:</span>
        <p>{totalTokens}</p>
      </div>
      <div className="flex gap-2">
        <span className="font-bold">Last vesting date:</span>
        <p>{formattedLastVestingDate}</p>
      </div>
      <div className="flex gap-2">
        <span className="font-bold">Average received percentage:</span>
        <p>{formattedAverageReceivedPercentage}%</p>
      </div>
      </div>
      <div className="w-2/3">
        <span className="font-bold">Distribution by blockchain:</span>
        {totalTokens > 0 ? (
          <ul className="w-full space-y-2">
            {repartitionPercentage.map(({ blockchain, percentage }) => (
              <li key={blockchain} className="flex items-center justify-between">
                <span className="w-1/4">{blockchain}:</span>
                <div className="w-2/4 bg-gray-200 rounded-full h-2.5 mr-2">
                  <div
                    className="bg-green-600 h-2.5 rounded-full"
                    style={{ width: `${percentage}%` }}
                  ></div>
                </div>
                <span className="w-1/4">{percentage}%</span>
              </li>
            ))}
          </ul>
        ) : (
          <p>Aucun token surveillé</p>
        )}
      </div>
      </div>
      <div
        onClick={toggleHidden}
        className="flex items-center mt-10 text-2xl font-bold cursor-pointer"
      >
        <span className="mr-2">My informations</span>
        <ArrowUp isHidden={isHidden} />
      </div>
      <div
        onSubmit={toggleHidden}
        className={`${isHidden ? "hidden" : "block"}`}
      >
        <form
          onSubmit={handleEdit}
          className={`w-9/12 md:w-1/3 m-auto flex flex-col items-center gap-y-2 ${
            isEditing ? "block" : "hidden"
          }`}
        >
          <label className="w-full">
            Name:
            <input
              type="text"
              name="name"
              value={editedUserData.name || ""}
              placeholder={userData?.user?.name}
              onChange={handleInputChange}
              className="w-full px-2 py-3 pr-4 text-gray-500 border rounded-md outline-none focus:bg-white focus:border-indigo-600"
            />
          </label>
          <br />
          <label className="w-full">
            Email:
            <input
              type="email"
              name="email"
              value={editedUserData.email || ""}
              placeholder={userData?.user?.email}
              onChange={handleInputChange}
              className="w-full px-2 py-3 pr-4 text-gray-500 border rounded-md outline-none focus:bg-white focus:border-indigo-600"
            />
          </label>
          <br />
          <label className="w-full">
            Address:
            <input
              type="text"
              name="address"
              value={editedUserData.address || ""}
              placeholder={userData?.user?.address}
              onChange={handleInputChange}
              className="w-full px-2 py-3 pr-4 text-gray-500 border rounded-md outline-none focus:bg-white focus:border-indigo-600"
            />
          </label>
          <br />
          <button
            type="submit"
            className="bg-blue-500 hover:bg-blue-700 text-white font-bold px-10 py-3.5 rounded w-full"
          >
            Confirm edit
          </button>
        </form>
        <div
          className={`w-9/12 md:w-1/3 m-auto flex flex-col gap-y-2 mb-4 ${
            isEditing ? "hidden" : "block"
          }`}
        >
          <span>Name:</span>
          <p className="input-1">
            {userData?.user?.name}
          </p>
          <span>Email:</span>
          <p className="input-1">
            {userData?.user?.email}
          </p>
          <span>Address:</span>
          <p className="w-full px-2 py-3 pr-4 text-gray-500 truncate border rounded-md outline-none bg-gray-50 focus:bg-white focus:border-indigo-600">
            {userData?.user?.address}
          </p>
        </div>
        <div className="w-9/12 m-auto font-bold md:w-1/3 md:mt-4">
          <ButtonPrimary
            text={isEditing ? "Cancel edit" : "Edit"}
            className={`${
              isEditing
                ? "bg-red-500 hover:bg-red-500 text-white border-red-500"
                : "bg-blue-600 hover:bg-blue-500 text-white"
            }`}
            func={() => setIsEditing(!isEditing)}
          />
        </div>
      </div>
      <div
        onClick={() => setIsPasswordHidden(!isPasswordHidden)}
        className="flex items-center mt-10 text-2xl font-bold cursor-pointer"
      >
        <span className="mr-2">Change password</span>
        <ArrowUp isHidden={isPasswordHidden} />
      </div>
      <form onSubmit={handleChangePassword} className={`w-9/12 md:w-1/3 m-auto flex flex-col gap-y-2 mb-4 ${
            isPasswordHidden ? "hidden" : "block"
          }`}>
          <label htmlFor="oldPassword">Current password:</label>
          <input
            type="password"
            id="oldPassword"
            name="oldPassword"
            value={oldPassword}
            onChange={(event) => setOldPassword(event.target.value)}
            className="w-full px-2 py-3 pr-4 text-gray-500 border rounded-md outline-none focus:bg-white focus:border-indigo-600"
          />

          <label htmlFor="newPassword">New password:</label>
          <input
            type="password"
            id="newPassword"
            name="newPassword"
            value={newPassword}
            onChange={(event) => setNewPassword(event.target.value)}
            className="w-full px-2 py-3 pr-4 text-gray-500 border rounded-md outline-none focus:bg-white focus:border-indigo-600"
          />

          {errorMessage && (
            <p className="text-red-500">{errorMessage}</p>
          )}

          <button type="submit" className="px-4 py-2 mt-3 text-white bg-indigo-600 rounded-lg">
            Change password
          </button>
        </form>
    </div>
  );
};

export default ProfileInfos;
